import React, { SVGProps } from 'react'

import { IconTemplateIPortIcon } from '@/shared/lib/@deprecated/iport-icons/template/IconTemplateIPortIcon'
import { CustomIconProps } from '@/shared/ui/icon-template'

export const SvgHandBook = (props: SVGProps<SVGSVGElement> & CustomIconProps) => {
	return (
		<IconTemplateIPortIcon height={30} width={44} {...props}>
			<svg viewBox="0 0 24 30" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g id="Frame 277131278">
					<path
						id="Vector 47"
						d="M6.4974 0.749999L19.9141 0.75L19.9141 23.25C19.9141 26.5637 17.2278 29.25 13.9141 29.25L2.4974 29.25L2.4974 4.75C2.4974 2.54086 4.28826 0.749999 6.4974 0.749999Z"
						fill="url(#paint0_linear_17991_10023)"
					/>
					<path
						id="Vector 48"
						d="M8.83333 0.749999L21.5 0.75L21.5 25.25C21.5 27.4591 19.7091 29.25 17.5 29.25L8.83333 29.25L8.83333 0.749999Z"
						fill="#545563"
					/>
					<path
						id="Union"
						d="M17.5408 5.5C17.9778 5.5 18.332 5.85424 18.332 6.29121C18.332 6.72819 17.9778 7.08243 17.5408 7.08243L6.45656 7.08243C6.01959 7.08243 5.66535 6.72819 5.66535 6.29121C5.66535 5.85424 6.01959 5.5 6.45656 5.5L17.5408 5.5Z"
						fill="white"
					/>
					<path
						id="Union_2"
						d="M17.5408 10.25C17.9778 10.25 18.332 10.6042 18.332 11.0412C18.332 11.4782 17.9778 11.8324 17.5408 11.8324L6.45656 11.8324C6.01959 11.8324 5.66535 11.4782 5.66535 11.0412C5.66535 10.6042 6.01959 10.25 6.45656 10.25L17.5408 10.25Z"
						fill="white"
					/>
					<path
						id="Union_3"
						d="M12.7908 14.998C13.2278 14.998 13.582 15.3523 13.582 15.7893C13.582 16.2262 13.2278 16.5805 12.7908 16.5805L6.45661 16.5805C6.01964 16.5805 5.6654 16.2262 5.6654 15.7893C5.6654 15.3523 6.01964 14.998 6.45661 14.998L12.7908 14.998Z"
						fill="white"
					/>
				</g>
				<defs>
					<linearGradient
						id="paint0_linear_17991_10023"
						x1="0.914062"
						y1="31.3875"
						x2="0.914063"
						y2="0.749999"
						gradientUnits="userSpaceOnUse">
						<stop stopColor="#E4EDFC" />
						<stop offset="1" stopColor="#568DFE" />
					</linearGradient>
				</defs>
			</svg>
		</IconTemplateIPortIcon>
	)
}
